var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreativesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72727 9.69351V19.2935L16.3636 14.4935L8.72727 9.69351ZM21.8182 4.89351H13.5491L17.1382 0.945506L16.3636 0.0935059L12 4.89351H11.9673L7.60364 0.0935059L6.85091 0.945506L10.4291 4.89351H2.18182C0.981818 4.89351 0 5.97351 0 7.29351V21.6935C0 23.0135 0.981818 24.0935 2.18182 24.0935H21.8182C23.0182 24.0935 24 23.0135 24 21.6935V7.29351C24 5.97351 23.0182 4.89351 21.8182 4.89351ZM21.8182 21.6935H2.18182V7.29351H21.8182V21.6935Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativesIcon);
export default __webpack_public_path__ + "static/media/creatives-icon.f8c4c3acb526d2f6060cdfee940aafec.svg";
export { ForwardRef as ReactComponent };